export default "__VITE_ASSET__DvpMuXZt__"